export const openTab = (url:string):void => window.open(url, '_blank')?.focus();
